<template >
    <div v-if="isDevelopment()">
        <label class="v-label">
            »@@variable_TEST«
            <span>(Esta variable únicamente aparecerá en test)</span>
        </label>
        <div v-html="field.etiqueta" class="mt-2"></div>
    </div>
</template>

<script>
    export default {
        name: "VariableTest",
        props: ['field', 'name'],

        methods: {
            isDevelopment(){
                return process.env.NODE_ENV === 'development'
            }
        }
    }
</script>

<style scoped>

</style>